export interface ProductGiftcardConfigModel {
  id: string;
  has_expiration_date: boolean;
  expiration_unit: ExpirationType;
  expires_in: number | null;
  // PAUL-3008: marks this product as the company's default gift-card product — the one refund-issued
  // gift cards are linked to (and take their G/L account from). At most one per company: the backend
  // clears the flag on the company's other gift-card products, so the previously-default product
  // comes back with is_default = false on its next fetch. Only writable through
  // PUT v1.0/products/giftcard; the full product Add/Edit ignores it.
  is_default: boolean;
}

export enum ExpirationType {
  YearsFromNow = 0,
  DaysFromNow = 1,
}
